import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
export function InlineBooleanField(props) {
    const { value, onChange, label, canEdit = false, size = 'small' } = props;
    const handleChange = React.useCallback((event) => {
        onChange(event.target.checked);
    }, [onChange]);
    const switchElement = (_jsx(Switch, { checked: value, onChange: handleChange, disabled: !canEdit, size: size }));
    if (label) {
        return (_jsx(FormControlLabel, { control: switchElement, label: label, disabled: !canEdit, sx: { marginLeft: 0 } }));
    }
    return switchElement;
}
//# sourceMappingURL=InlineBooleanField.js.map